export default __webpack_public_path__ + "static/media/esophagus3.3fbfd5ee.jpg";